// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Data Grid Component Styles */

.data-grid-container {
  width: 100%;
}

.grid-title {
  margin-bottom: 20px;
  color: #333;
}

/* Search Container */
.search-container {
  margin-bottom: 20px;
}

.search-container .search-field {
  width: 100%;
}

/* Table Container */
.table-container {
  width: 100%;
  overflow-x: auto;
}

.data-grid-table {
  width: 100%;
  min-width: 600px;
}

/* Header Styling */
.data-grid-table .mat-mdc-header-row {
  height: 56px;
}

.sticky-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background-color: #f5f5f5;
}

/* Filter Row Styling */
.filter-row {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  height: 48px;
  min-height: 48px;
}

.filter-row .mat-mdc-cell {
  padding: 8px 12px;
  border-bottom: none;
}

.filter-input {
  width: 100%;
  font-size: 12px;
  border-radius: 4px;
  border: 1px solid #ced4da;
  padding: 4px 8px;
  background-color: white;
}

.filter-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.filter-input::placeholder {
  color: #6c757d;
  font-style: italic;
}

/* Data Row Styling */
.data-row {
  height: 48px;
  transition: background-color 0.2s;
}

.data-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Action Cell Styling */
.action-cell {
  text-align: center;
  padding: 8px !important;
}

.action-button {
  margin: 0 2px;
  min-width: auto;
  padding: 4px 8px;
  font-size: 12px;
}

/* Table Cell Styling */
.mat-mdc-cell, .mat-mdc-header-cell {
  padding: 12px 8px !important;
  text-align: left;
}

.mat-mdc-cell {
  font-size: 14px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.mat-mdc-header-cell {
  font-weight: 600;
  color: #333;
  background-color: #f5f5f5;
}

/* Sort Header Styling */
.mat-sort-header-content {
  white-space: nowrap;
}

/* Total Count */
.total-count {
  margin-top: 16px;
  font-size: 14px;
  color: #666;
  text-align: right;
  padding: 0 8px;
}

/* Paginator Styling */
mat-paginator {
  margin-top: 16px;
}

mat-paginator .mat-mdc-paginator-container {
  justify-content: center;
}

/* Responsive Design */
@media (max-width: 768px) {
  .data-grid-table {
    font-size: 12px;
  }
  
  .mat-mdc-cell, .mat-mdc-header-cell {
    padding: 8px 4px !important;
  }
  
  .action-button {
    padding: 2px 4px;
    font-size: 10px;
  }
}

/* Loading and Error States */
.alert {
  padding: 12px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

/* Utility Classes */
.text-center {
  text-align: center;
}

.w-100 {
  width: 100%;
}

/* Material Design Overrides */
.mat-mdc-table {
  background: white;
}

.mat-mdc-row:hover {
  background-color: rgba(0, 0, 0, 0.04);
}

/* Custom scrollbar for table container */
.table-container::-webkit-scrollbar {
  height: 8px;
}

.table-container::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.table-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.table-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`, "",{"version":3,"sources":["webpack://./projects/tilmanagement/src/app/shared/data-grid/data-grid.component.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,uBAAuB;AACvB;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,yCAAyC;AACzC;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Data Grid Component Styles */\n\n.data-grid-container {\n  width: 100%;\n}\n\n.grid-title {\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Search Container */\n.search-container {\n  margin-bottom: 20px;\n}\n\n.search-container .search-field {\n  width: 100%;\n}\n\n/* Table Container */\n.table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.data-grid-table {\n  width: 100%;\n  min-width: 600px;\n}\n\n/* Header Styling */\n.data-grid-table .mat-mdc-header-row {\n  height: 56px;\n}\n\n.sticky-header {\n  position: sticky;\n  top: 0;\n  z-index: 1000;\n  background-color: #f5f5f5;\n}\n\n/* Filter Row Styling */\n.filter-row {\n  background-color: #f8f9fa;\n  border-bottom: 1px solid #dee2e6;\n  height: 48px;\n  min-height: 48px;\n}\n\n.filter-row .mat-mdc-cell {\n  padding: 8px 12px;\n  border-bottom: none;\n}\n\n.filter-input {\n  width: 100%;\n  font-size: 12px;\n  border-radius: 4px;\n  border: 1px solid #ced4da;\n  padding: 4px 8px;\n  background-color: white;\n}\n\n.filter-input:focus {\n  border-color: #80bdff;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);\n}\n\n.filter-input::placeholder {\n  color: #6c757d;\n  font-style: italic;\n}\n\n/* Data Row Styling */\n.data-row {\n  height: 48px;\n  transition: background-color 0.2s;\n}\n\n.data-row:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n/* Action Cell Styling */\n.action-cell {\n  text-align: center;\n  padding: 8px !important;\n}\n\n.action-button {\n  margin: 0 2px;\n  min-width: auto;\n  padding: 4px 8px;\n  font-size: 12px;\n}\n\n/* Table Cell Styling */\n.mat-mdc-cell, .mat-mdc-header-cell {\n  padding: 12px 8px !important;\n  text-align: left;\n}\n\n.mat-mdc-cell {\n  font-size: 14px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.mat-mdc-header-cell {\n  font-weight: 600;\n  color: #333;\n  background-color: #f5f5f5;\n}\n\n/* Sort Header Styling */\n.mat-sort-header-content {\n  white-space: nowrap;\n}\n\n/* Total Count */\n.total-count {\n  margin-top: 16px;\n  font-size: 14px;\n  color: #666;\n  text-align: right;\n  padding: 0 8px;\n}\n\n/* Paginator Styling */\nmat-paginator {\n  margin-top: 16px;\n}\n\nmat-paginator .mat-mdc-paginator-container {\n  justify-content: center;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .data-grid-table {\n    font-size: 12px;\n  }\n  \n  .mat-mdc-cell, .mat-mdc-header-cell {\n    padding: 8px 4px !important;\n  }\n  \n  .action-button {\n    padding: 2px 4px;\n    font-size: 10px;\n  }\n}\n\n/* Loading and Error States */\n.alert {\n  padding: 12px;\n  margin-bottom: 20px;\n  border: 1px solid transparent;\n  border-radius: 4px;\n}\n\n.alert-danger {\n  color: #721c24;\n  background-color: #f8d7da;\n  border-color: #f5c6cb;\n}\n\n/* Utility Classes */\n.text-center {\n  text-align: center;\n}\n\n.w-100 {\n  width: 100%;\n}\n\n/* Material Design Overrides */\n.mat-mdc-table {\n  background: white;\n}\n\n.mat-mdc-row:hover {\n  background-color: rgba(0, 0, 0, 0.04);\n}\n\n/* Custom scrollbar for table container */\n.table-container::-webkit-scrollbar {\n  height: 8px;\n}\n\n.table-container::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n\n.table-container::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 4px;\n}\n\n.table-container::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
